module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "fixed-pane",
    class: _vm.wrapperClasses,
    attrs: {
      "id": "cookie-overlay"
    }
  }, [_c('div', {
    staticClass: "inner"
  }, [(!_vm.agreed) ? _c('div', [_c('p', {
    staticClass: "message",
    domProps: {
      "innerHTML": _vm._s(_vm.notice)
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "agree",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.agree($event)
      }
    }
  }, [_vm._v("Agree")]), _vm._v(" "), _c('button', {
    staticClass: "disagree",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.disagree($event)
      }
    }
  }, [_vm._v("Disagree")])]) : _vm._e(), _vm._v(" "), (_vm.agreed) ? _c('p', {
    staticClass: "message",
    domProps: {
      "innerHTML": _vm._s(_vm.thankyou)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.disagreed) ? _c('p', {
    staticClass: "message",
    domProps: {
      "innerHTML": _vm._s(_vm.disagreedMessage)
    }
  }) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ca1665d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CookieCompliance.vue
// module id = 96
// module chunks = 1